import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { DiscussionListConfig, Profile } from "../../../../shared";

@Component({
  selector: "voted-discussions",
  templateUrl: "./voted-discussions.component.html",
})
export class VotedDiscussionsComponent implements OnInit {
  public profile: Profile;
  public config: DiscussionListConfig = new DiscussionListConfig();

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.parent.data.subscribe((data: { profile: Profile }) => {
      this.profile = data.profile;
      this.config.filters.votedBy = this.profile.username;
    });
  }
}
